<template>
    <div class="d-flex flex-column flex-md-row align-items-center py-4 py-md-5">
        <!-- SELECT TIPOLOGIA MOBILE -->
        <div class="col-12 d-md-none">
            <div class="row">
                <div class="col-12 zp-cotizador-input-container">
                    <div class="zp-cotizador-input-label">
                        Selecciona la tipología
                    </div>
                    <v-select-c
                        v-model="
                            $v.firstSectionMobile.tipologySelected.$model
                        "
                        placeholder="Selecciona la tipología"
                        :options="selectors.tipology"
                        @input="renderModelMobile()"
                        :class="
                            !$v.firstSectionMobile.tipologySelected.$anyError
                                ? ''
                                : 'zp-select-form-error'
                        "
                    >
                        <div slot="no-options">
                            No se encontraron tipos
                        </div>
                    </v-select-c>
                    <div
                        class="zp-error-span error-data"
                        v-if="$v.firstSectionMobile.tipologySelected.$dirty"
                    >
                        <span
                            v-if="
                                !$v.firstSectionMobile.tipologySelected
                                    .required
                            "
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
                <div class="col-12 zp-cotizador-input-container">
                    <div class="zp-cotizador-input-label">
                        Selecciona la unidad
                    </div>
                    <v-select-c
                        v-model="$v.firstSectionMobile.typeSelected.$model"
                        placeholder="Selecciona la unidad"
                        :options="selectors.type"
                        :class="
                            !$v.firstSectionMobile.typeSelected.$anyError
                                ? ''
                                : 'zp-select-form-error'
                        "
                        @input="renderAdicionalUnit($event)"
                    >
                        <template slot="option" slot-scope="option">
                            {{ option.label }}
                            <div style="font-size: 0.7rem">
                                Piso: {{ option.property.piso }} |
                                {{
                                    option.property.orientacion
                                        .descripcion
                                }}
                                |
                                {{ option.property.superficie_total }}
                                m<sup>2</sup>
                            </div>
                        </template>
                        <div slot="no-options">
                            No se encontraron unidades
                        </div>
                    </v-select-c>
                    <div
                        class="zp-error-span error-data"
                        v-if="$v.firstSectionMobile.typeSelected.$dirty"
                    >
                        <span
                            v-if="
                                !$v.firstSectionMobile.typeSelected.required
                            "
                            class="zp-error-span"
                        >
                            <i
                                class="fas fa-exclamation-circle text-danger"
                            ></i>
                            Campo necesario
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- FIN SELECT TIPOLOGIA MOBILE -->
        <div
            id="carousel-thumb"
            v-if="plantasUrl.length > 0 && !showInfoProperty"
            data-ride="carousel"
            class="carousel slide carousel-fade carousel-thumbnails list-gallery zp-carga-lenta col-12 col-md-4"
        >
            <div class="carousel-inner" role="listbox">
                <div
                    v-for="(img, i) in plantasUrl"
                    :key="i"
                    :lote="img.lote"
                    :idUnidades="img.id"
                    :modelo="img.modelo"
                    :piso="img.piso"
                    :orientacion_id="img.orientacion_id"
                    :class="
                        i === 0
                            ? 'carousel-item carousel-item-quote active'
                            : 'carousel-item carousel-item-quote'
                    "
                >
                    <img
                        class="d-block img-quote"
                        :src="i == 0 ? img.planta_url : ''"
                        :data-src="img.planta_url"
                        alt="slide"
                    />
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4" v-if="showInfoProperty">
            <img
                class="d-block img-quote"
                :src="'/'+selectedProperty.planta_url"
                :data-src="'/'+selectedProperty.planta_url"
                alt="slide"
            />
        </div>
        <!-- DATOS PROPIEDAD MOBILE -->
        <div class="col-12 d-md-none" v-if="showInfoProperty">
            <div class="px-0 d-flex flex-column">
                <div
                    class="text-center d-flex flex-column justify-content-center flex-grow-1"
                >
                    <div
                        class="font-weight-bold d-flex justify-content-between my-4"
                        style="color: #aaa; font-size: 1.1rem"
                    >
                        <div class="w-100">
                            <span class="d-block">{{ selectedProperty.dormitorios }}</span>
                            <span class="d-block">Dorm</span>
                        </div>
                        <div
                            class="w-100"
                            style="border-left: 1px solid #aaa"
                        >
                            <span class="d-block">{{ selectedProperty.banos }}</span>
                            <span class="d-block">Baños</span>
                        </div>
                        <div
                            class="w-100"
                            style="border-left: 1px solid #aaa"
                        >
                            <span class="d-block">{{ selectedProperty.superficie_total }}</span>
                            <span class="d-block"
                                >m<sup>2</sup></span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3 d-md-none">
            <button type="button" 
                class="btn btn-block bg-main-color general-btn text-white" 
                :disabled="selectedProperty === null"
                data-toggle="modal" 
                data-target="#exampleModal">
                COTIZAR
            </button>
        </div>
        <!-- FIN DATOS PROPIEDAD MOBILE -->
        <div class="col d-none d-md-block">
            <form
                id="form-cotizacion"
                action=""
                method="POST"
                @submit.prevent="enviarCotizacion"
                class="d-flex col-11 mx-auto"
            >
                <input type="hidden" name="_token" :value="csrf" />
                <input
                    type="hidden"
                    name="unidad"
                    :value="formularioCotizacion.unidad"
                />
                <input type="hidden" name="rut" :value="secondSection.rut" />
                <input
                    type="hidden"
                    name="telefono"
                    :value="secondSection.phone"
                />
                <input
                    type="hidden"
                    name="email"
                    :value="secondSection.email"
                />
                <input
                    type="hidden"
                    name="nombre"
                    :value="secondSection.name"
                />
                <div class="col-6">
                    <div class="row">
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">
                                Selecciona la tipología
                            </div>
                            <v-select-c
                                v-model="
                                    $v.firstSection.tipologySelected.$model
                                "
                                placeholder="Selecciona la tipología"
                                :options="selectors.tipology"
                                @input="renderModel()"
                                :class="
                                    !$v.firstSection.tipologySelected.$anyError
                                        ? ''
                                        : 'zp-select-form-error'
                                "
                            >
                                <div slot="no-options">
                                    No se encontraron tipos
                                </div>
                            </v-select-c>
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.firstSection.tipologySelected.$dirty"
                            >
                                <span
                                    v-if="
                                        !$v.firstSection.tipologySelected
                                            .required
                                    "
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Campo necesario
                                </span>
                            </div>
                        </div>
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">
                                Selecciona la unidad
                            </div>
                            <v-select-c
                                v-model="$v.firstSection.typeSelected.$model"
                                placeholder="Selecciona la unidad"
                                :options="selectors.type"
                                :class="
                                    !$v.firstSection.typeSelected.$anyError
                                        ? ''
                                        : 'zp-select-form-error'
                                "
                                @input="renderAdicionalUnit($event)"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ option.label }}
                                    <div style="font-size: 0.7rem">
                                        Piso: {{ option.property.piso }} |
                                        {{
                                            option.property.orientacion
                                                .descripcion
                                        }}
                                        |
                                        {{ option.property.superficie_total }}
                                        m<sup>2</sup>
                                    </div>
                                </template>
                                <div slot="no-options">
                                    No se encontraron unidades
                                </div>
                            </v-select-c>
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.firstSection.typeSelected.$dirty"
                            >
                                <span
                                    v-if="
                                        !$v.firstSection.typeSelected.required
                                    "
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Campo necesario
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="showInfoProperty">
                        <div class="col-12">
                            <div class="px-0 d-flex flex-column">
                                <div
                                    class="text-center d-flex flex-column justify-content-center flex-grow-1"
                                >
                                    <div
                                        class="font-weight-bold d-flex justify-content-between my-4"
                                        style="color: #aaa; font-size: 1.1rem"
                                    >
                                        <div class="w-100">
                                            <span class="d-block">{{ selectedProperty.dormitorios }}</span>
                                            <span class="d-block">Dorm</span>
                                        </div>
                                        <div
                                            class="w-100"
                                            style="border-left: 1px solid #aaa"
                                        >
                                            <span class="d-block">{{ selectedProperty.banos }}</span>
                                            <span class="d-block">Baños</span>
                                        </div>
                                        <div
                                            class="w-100"
                                            style="border-left: 1px solid #aaa"
                                        >
                                            <span class="d-block">{{ selectedProperty.superficie_total }}</span>
                                            <span class="d-block"
                                                >m<sup>2</sup></span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">Nombre</div>
                            <input
                                v-model="$v.secondSection.name.$model"
                                :class="
                                    !$v.secondSection.name.$anyError
                                        ? 'form-control'
                                        : 'form-control form-error zp-select-form-error'
                                "
                                placeholder="Nombre"
                                @keypress="onlyLetters"
                                type="text"
                            />
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.secondSection.name.$dirty"
                            >
                                <span
                                    v-if="!$v.secondSection.name.required"
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Campo necesario
                                </span>
                            </div>
                        </div>
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">RUT</div>
                            <input
                                v-model="$v.secondSection.rut.$model"
                                :class="
                                    !$v.secondSection.rut.$anyError
                                        ? 'form-control'
                                        : 'form-control form-error zp-select-form-error'
                                "
                                placeholder="RUT"
                                type="text"
                                maxlength="12"
                                name="rut"
                                v-rut:live
                            />
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.secondSection.rut.$dirty"
                            >
                                <span
                                    v-if="!$v.secondSection.rut.required"
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Campo necesario
                                </span>
                                <span
                                    v-if="
                                        (!$v.secondSection.rut.rutValidation ||
                                            !$v.secondSection.rut.minLength) &&
                                        $v.secondSection.rut.required
                                    "
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    RUT inválido
                                </span>
                            </div>
                        </div>
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">Email</div>
                            <input
                                v-model="$v.secondSection.email.$model"
                                :class="
                                    !$v.secondSection.email.$anyError
                                        ? 'form-control'
                                        : 'form-control form-error zp-select-form-error'
                                "
                                placeholder="Email"
                                type="email"
                            />
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.secondSection.email.$dirty"
                            >
                                <span
                                    v-if="!$v.secondSection.email.email"
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Email inválido
                                </span>
                            </div>
                        </div>
                        <div class="col-12 zp-cotizador-input-container">
                            <div class="zp-cotizador-input-label">Teléfono</div>
                            <input
                                type="text"
                                class="form-control"
                                v-model="$v.secondSection.phone.$model"
                                :class="
                                    !$v.secondSection.phone.$anyError
                                        ? 'form-control'
                                        : 'form-control form-error zp-select-form-error'
                                "
                                name="telefono"
                                maxlength="9"
                                placeholder="Teléfono"
                                @keypress="onlyNumber"
                                required
                            />
                            <div
                                class="zp-error-span error-data"
                                v-if="$v.secondSection.phone.$dirty"
                            >
                                <span v-if="!phoneValid" class="zp-error-span">
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Campo necesario
                                </span>
                                <span
                                    v-if="!$v.secondSection.phone.minLength"
                                    class="zp-error-span"
                                >
                                    <i
                                        class="fas fa-exclamation-circle text-danger"
                                    ></i>
                                    Número inválido
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="row d-flex justify-content-between"
                        style="margin-top: 1rem"
                    >
                        <div class="col-12">
                            <button
                                type="submit"
                                :disabled="ocultarBotones || selectedProperty === null || $v.secondSection.$invalid
                                "
                                class="btn btn-block bg-main-color general-btn text-white"
                            >
                                {{ textoBotonEnviar }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="zp-modal-head">
                        <button type="button" class="close mt-3 mr-3" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h2 class="font-weight-bold">
                            <span class="color-main-color">//</span>
                            <span> Completa tus datos</span>
                        </h2>
                    </div>
                    <div class="modal-body d-flex align-items-center">
                        <div class="col">
                            <form
                                id="form-cotizacion-mobile"
                                action=""
                                method="POST"
                                @submit.prevent="enviarCotizacionMobile"
                                class="d-flex">
                                <input type="hidden" name="_token" :value="csrf" />
                                <input type="hidden" name="unidad" :value="selectedProperty?.id"/>
                                <input type="hidden" name="rut" :value="secondSection.rut" />
                                <input type="hidden" name="telefono" :value="secondSection.phone"/>
                                <input type="hidden" name="email" :value="secondSection.email"/>
                                <input type="hidden" name="nombre" :value="secondSection.name"/>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 zp-cotizador-input-container">
                                            <div class="zp-cotizador-input-label">Nombre</div>
                                            <input
                                                v-model="$v.secondSection.name.$model"
                                                :class="!$v.secondSection.name.$anyError ? 'form-control' : 'form-control form-error zp-select-form-error'"
                                                placeholder="Nombre"
                                                @keypress="onlyLetters"
                                                type="text"
                                            />
                                            <div class="zp-error-span error-data" v-if="$v.secondSection.name.$dirty">
                                                <span v-if="!$v.secondSection.name.required" class="zp-error-span">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    Campo necesario
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-12 zp-cotizador-input-container">
                                            <div class="zp-cotizador-input-label">RUT</div>
                                            <input
                                                v-model="$v.secondSection.rut.$model"
                                                :class="!$v.secondSection.rut.$anyError ? 'form-control' : 'form-control form-error zp-select-form-error'"
                                                placeholder="RUT"
                                                type="text"
                                                maxlength="12"
                                                name="rut"
                                                v-rut:live
                                            />
                                            <div class="zp-error-span error-data" v-if="$v.secondSection.rut.$dirty">
                                                <span v-if="!$v.secondSection.rut.required" class="zp-error-span">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    Campo necesario
                                                </span>
                                                <span class="zp-error-span"
                                                    v-if="
                                                        (!$v.secondSection.rut.rutValidation ||
                                                            !$v.secondSection.rut.minLength) &&
                                                        $v.secondSection.rut.required">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    RUT inválido
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-12 zp-cotizador-input-container">
                                            <div class="zp-cotizador-input-label">Email</div>
                                            <input
                                                v-model="$v.secondSection.email.$model"
                                                :class="!$v.secondSection.email.$anyError ? 'form-control' : 'form-control form-error zp-select-form-error'"
                                                placeholder="Email"
                                                type="email"
                                            />
                                            <div class="zp-error-span error-data" v-if="$v.secondSection.email.$dirty">
                                                <span v-if="!$v.secondSection.email.email" class="zp-error-span">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    Email inválido
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-12 zp-cotizador-input-container">
                                            <div class="zp-cotizador-input-label">Teléfono</div>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="$v.secondSection.phone.$model"
                                                :class="!$v.secondSection.phone.$anyError ? 'form-control' : 'form-control form-error zp-select-form-error'"
                                                name="telefono"
                                                maxlength="9"
                                                placeholder="Teléfono"
                                                @keypress="onlyNumber"
                                                required
                                            />
                                            <div class="zp-error-span error-data" v-if="$v.secondSection.phone.$dirty">
                                                <span v-if="!phoneValid" class="zp-error-span">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    Campo necesario
                                                </span>
                                                <span v-if="!$v.secondSection.phone.minLength" class="zp-error-span">
                                                    <i class="fas fa-exclamation-circle text-danger"></i>
                                                    Número inválido
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between p-3 mt-4 letter-color-black font-weight-bold" style="background-color: #aaa;">
                                        <span>Modelo: {{ selectedProperty?.modelo }}</span>
                                        <span>Unidad: {{ selectedProperty?.lote }}</span>
                                    </div>
                                    <div class="row d-flex justify-content-between pt-5">
                                        <div class="col-12">
                                            <button
                                                style="height: 2.5rem !important;"
                                                type="submit"
                                                :disabled="ocultarBotones || selectedProperty === null || $v.secondSection.$invalid"
                                                class="btn btn-block bg-main-color general-btn text-white"
                                            >
                                                {{ textoBotonEnviar }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { rutValidator, rutInputDirective } from 'vue-dni'
import Vuetify from 'vuetify'
Vue.use(Vuetify)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select-c', vSelect)

Vue.directive('rut', rutInputDirective)

export default {
    name: 'FormularioCotizacion',
    props: [
        'rutacotizacion',
        'rutareserva',
        'unidades',
        'parkinglot',
        'estacionamientos',
        'bodegas',
        'warehouse',
        'restricciones',
        'modelos',
        'url_imagenes',
        'proyectoid',
        'proyectoslug'
    ],
    data: function () {
        return {
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content'),
            ocultarBotones: false,
            plantasUrlInicial: [],
            plantasUrl: [],
            selectors: {
                tipology: [],
                model: [],
                floor: [],
                orientation: [],
                type: [],
                floor_medias: [],
                parkinglot: [],
                warehouse: []
            },
            subsidies: [],
            propertySelectedFromDropdown: {
                vulnerable: '0',
                sectores_medios: '0'
            },
            parkinglotCheck: false,
            warehouseCheck: false,
            disabledParkinglot: false,
            disabledWarehouse: false,
            loadingQuote: false,
            sheetQuote: false,
            phoneOptions: {
                placeholder: 'Ingrese su número',
                maxlength: 9
            },
            phoneDropdownOptions: {
                showFlags: true,
                showDialCodeInSelection: true
            },
            steper: 1,
            firstSection: {
                tipologySelected: null,
                modeSelected: null,
                orientationSelected: null,
                floorSelected: null,
                typeSelected: null,
                parkinglot: null,
                wawrehosue: null
            },
            firstSectionMobile: {
                tipologySelected: null,
                modeSelected: null,
                orientationSelected: null,
                floorSelected: null,
                typeSelected: null,
                parkinglot: null,
                wawrehosue: null
            },
            simulation_payment: [],
            simulation_subsidy: [],
            phoneForm: null,
            phoneValid: true,
            propertySelected: {},
            property_quote: {},
            quote_result: {},
            secondSection: {
                rut: null,
                name: null,
                phone: null,
                email: null,
                subsidy: null
            },
            floorMediasToRender: [],
            formularioCotizacion: {
                unidad: '',
                estacionamiento: '',
                bodega: '',
                reservable: 0
            },
            cargandoFormulario: false,
            textoBotonEnviar: 'COTIZAR',
            textoBotonReserva: 'Reservar',
            showInfoProperty: false,
            selectedProperty: null,
        }
    },
    validations: {
        firstSection: {
            tipologySelected: {
                required
            },
            modeSelected: {
                required
            },
            orientationSelected: {
                required
            },
            floorSelected: {
                required
            },
            typeSelected: {
                required
            }
        },
        firstSectionMobile: {
            tipologySelected: {
                required
            },
            modeSelected: {
                required
            },
            orientationSelected: {
                required
            },
            floorSelected: {
                required
            },
            typeSelected: {
                required
            }
        },
        secondSection: {
            rut: {
                required,
                rutValidation: rutValidator,
                minLength: minLength(9)
            },
            name: {
                required
            },
            phone: {
                required,
                minLength: minLength(9)
            },
            email: {
                required,
                email
            }
        }
    },
    watch: {
        'firstSection.parkinglot': function (newValue, oldValue) {
            this.formularioCotizacion.estacionamiento = newValue
        },
        'firstSection.wawrehosue': function (newValue, oldValue) {
            this.formularioCotizacion.bodega = newValue
        },
        parkinglotCheck: function (newValue, oldValue) {
            if (!newValue) {
                this.formularioCotizacion.estacionamiento = ''
            }
        },
        warehouseCheck: function (newValue, oldValue) {
            if (!newValue) {
                this.formularioCotizacion.bodega = ''
            }
        },
        'firstSection.typeSelected': function (newValue, oldValue) {
            this.seleccionaPrimerElementoCarrusel()
            if (newValue != null) {
                this.formularioCotizacion.unidad = newValue.id
                this.formularioCotizacion.reservable = newValue.reservable
            } else {
                this.formularioCotizacion.unidad = ''
                this.plantasUrl = this.plantasUrlInicial
            }
        }
    },
    mounted () {
        this.unidades.map(p => {
            if (
                this.selectors.tipology.indexOf(
                    p.dormitorios + ' Dorm ' + p.banos + ' Baños'
                ) === -1
            ) {
                this.selectors.tipology.push(
                    p.dormitorios + ' Dorm ' + p.banos + ' Baños'
                )
            }
        })
        this.unidades.map(p => {
            let tipologia_objeto =
                p.tipologias.length > 0
                    ? p.tipologias[0].tipologia
                    : { media: '' }

            if (
                this.plantasUrlInicial.find(
                    m => m.planta_url === p.planta_url
                ) === undefined &&
                tipologia_objeto.media != '' &&
                tipologia_objeto.media != null &&
                tipologia_objeto.media != undefined
            ) {
                this.plantasUrlInicial.push({
                    id: p.id,
                    modelo: p.modelo,
                    lote: p.lote,
                    orientacion_id: p.orientacion_id,
                    piso: p.piso,
                    planta_url:
                        tipologia_objeto.media.startsWith('/') ||
                        tipologia_objeto.media.startsWith('http')
                            ? tipologia_objeto.media
                            : '/' + tipologia_objeto.media
                })
            }
        })
        this.plantasUrl = this.plantasUrlInicial
    },
    computed: {
        renderFloorImages () {
            if (this.floorMediasToRender.length > 0) {
                return this.floorMediasToRender.length
            } else {
                return 0 //fix this
            }
        },
        renderParkinglot () {
            if (
                !this.disabledParkinglot &&
                this.firstSection.typeSelected !== null &&
                this.parkinglot.length > 0
            ) {
                let parkinglot = []
                this.parkinglot
                    .filter(
                        p =>
                            //p.available == 1 &&
                            //this.estacionamientos.filter((a) => a.id === p.id).length === 0
                            true
                    )
                    .map(com => {
                        let label_quote = ''
                        if (parseFloat(com.superficie_total) > 0) {
                            label_quote =
                                com.lote +
                                ' - ' +
                                com.superficie_total +
                                'mts2 ' +
                                ' - piso ' +
                                com.piso
                        } else {
                            label_quote = com.lote + ' - piso ' + com.piso
                        }
                        parkinglot.push({
                            id: com.id,
                            label: label_quote
                        })
                    })

                let self = this
                if (this.restricciones.length > 0) {
                    var estacionamiento_filtrado = []
                    this.restricciones.forEach(function (valor, indice, array) {
                        valor.restricciones.forEach(function (
                            valorRestricciones,
                            indiceRestricciones,
                            arrayRestricciones
                        ) {
                            if (
                                valorRestricciones.unidad_id ==
                                self.firstSection.typeSelected.id
                            ) {
                                estacionamiento_filtrado.push(
                                    valorRestricciones.estacionamiento_id
                                )
                            }
                        })
                    })
                    if (estacionamiento_filtrado.length > 0) {
                        var parkinglot_showed = []
                        parkinglot.forEach(function (valor, indice, array) {
                            estacionamiento_filtrado.forEach(function (
                                valorRestricciones,
                                indiceRestricciones,
                                arrayRestricciones
                            ) {
                                if (valor.id == valorRestricciones) {
                                    parkinglot_showed.push(valor)
                                }
                            })
                        })
                        parkinglot = parkinglot_showed
                    }
                    return parkinglot
                } else {
                    return parkinglot
                }
            } else {
                return this.estacionamientos
            }
        },
        renderWarehouse () {
            if (
                !this.disabledWarehouse &&
                this.firstSection.typeSelected !== null &&
                this.warehouse.length > 0
            ) {
                let warehouse = []
                this.warehouse
                    .filter(
                        p =>
                            //p.available == 1 &&
                            //this.bodegas.filter((a) => a.id === p.id).length === 0
                            true
                    )
                    .map(com => {
                        let label_quote = ''

                        if (parseFloat(com.superficie_total) > 0) {
                            label_quote =
                                com.lote +
                                ' - ' +
                                com.superficie_total +
                                'mts2 ' +
                                ' - piso ' +
                                com.piso
                        } else {
                            label_quote = com.lote + ' - piso ' + com.piso
                        }
                        warehouse.push({
                            id: com.id,
                            label: label_quote
                        })
                    })

                let self = this
                if (this.restricciones.length > 0) {
                    var bodegas_filtradas = []
                    this.restricciones.forEach(function (valor, indice, array) {
                        valor.restricciones.forEach(function (
                            valorRestricciones,
                            indiceRestricciones,
                            arrayRestricciones
                        ) {
                            if (
                                valorRestricciones.unidad_id ==
                                self.firstSection.typeSelected.id
                            ) {
                                bodegas_filtradas.push(
                                    valorRestricciones.bodega_id
                                )
                            }
                        })
                    })
                    if (bodegas_filtradas.length > 0) {
                        var bodegas_mostradas = []
                        warehouse.forEach(function (valor, indice, array) {
                            bodegas_filtradas.forEach(function (
                                valorRestricciones,
                                indiceRestricciones,
                                arrayRestricciones
                            ) {
                                if (valor.id == valorRestricciones) {
                                    bodegas_mostradas.push(valor)
                                }
                            })
                        })
                        warehouse = bodegas_mostradas
                    }
                    this.selectors.warehouse = warehouse
                    return warehouse
                } else {
                    this.selectors.warehouse = warehouse
                    return warehouse
                }
            } else {
                return this.bodegas
            }
        }
    },
    methods: {
        seleccionaPrimerElementoCarrusel () {
            $('#carousel-thumb .carousel-item-quote').removeClass('active')
            $('#carousel-thumb .carousel-item-quote:first-child').addClass(
                'active'
            )
        },
        enviarReserva () {
            this.textoBotonReserva = 'Enviando...'
            this.ocultarBotones = true
            $('#form-cotizacion').attr('action', this.rutareserva).submit()
        },
        enviarCotizacion () {
            this.textoBotonEnviar = 'COTIZANDO...'
            this.ocultarBotones = true
            const ruta = `/proyecto/${this.proyectoid}/${this.proyectoslug}`
            $('#form-cotizacion').attr('action', ruta).submit()
        },
        enviarCotizacionMobile () {
            this.textoBotonEnviar = 'COTIZANDO...'
            this.ocultarBotones = true
            const ruta = `/proyecto/${this.proyectoid}/${this.proyectoslug}`
            $('#form-cotizacion-mobile').attr('action', ruta).submit()
        },
        onlyNumber ($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault()
            }
        },
        onlyLetters ($event) {
            var regex = new RegExp('^[a-zA-Z ñÑ]+$')
            var key = String.fromCharCode(
                !event.charCode ? event.which : event.charCode
            )
            if (!regex.test(key)) {
                event.preventDefault()
                return false
            }
        },
        closeSheet () {
            this.sheetQuote = false
            this.simulation_payment = []
            this.simulation_subsidy = []
            this.parkinglotCheck = false
            this.warehouseCheck = false
        },
        renderModel () {
            this.renderModelSelect(this.firstSection)
        },
        renderModelMobile () {
            this.renderModelSelect(this.firstSectionMobile)
        },
        renderModelSelect (sectionSelects) {
            sectionSelects.typeSelected = null
            this.showInfoProperty = false
            this.selectedProperty = null
            if (sectionSelects.tipologySelected !== null) {
                let filters = sectionSelects.tipologySelected.split(' ')
                this.selectors.type = []
                let property = this.unidades.filter(
                    p =>
                        p.dormitorios == parseInt(filters[0]) &&
                        p.banos == parseInt(filters[2])
                )
                property.map(p => {
                    if (
                        this.selectors.type.find(o => o.label === p.lote) ===
                        undefined
                    ) {
                        this.selectors.type.push({
                            id: p.id,
                            label: p.lote,
                            reservable: p.reservable,
                            property: p
                        })
                    }
                })
            }
        },
        renderOrientation () {
            this.agregarCarruselLento()
        },
        agregarCarruselLento () {
            $(function () {
                $('.carousel.zp-carga-lenta').bind(
                    'slide.bs.carousel',
                    function (e) {
                        let image = $(e.relatedTarget).find('img[data-src]')
                        if (
                            typeof image.attr('data-src') !== 'undefined' &&
                            image.attr('data-src') !== false
                        ) {
                            let url =
                                image.attr('data-src').startsWith('/') ||
                                image.attr('data-src').startsWith('http')
                                    ? image.attr('data-src')
                                    : '/' + image.attr('data-src')
                            image.attr('src', url)
                            image.removeAttr('data-src')
                        }
                    }
                )
            })
        },
        renderAdicionalUnit (event) {
            if (event == null) {
                this.showInfoProperty = false
                this.selectedProperty = null
                return
            }
            this.selectedProperty = event.property
            this.plantasUrl = this.selectedProperty.planta_url
            this.showInfoProperty = true
        },
        onChange: function (phone, { number, valid }) {
            if (phone === '' && this.$v.secondSection.phone.$model === null) {
                this.phoneValid = true
            } else if (
                phone === '' &&
                this.$v.secondSection.phone.$model === undefined
            ) {
                this.phoneValid = false
            } else if (
                phone !== '' &&
                this.$v.secondSection.phone.$model !== ''
            ) {
                this.phoneValid = true
            }
            this.$v.secondSection.phone.$model = number
        }
    }
}
</script>

<style scoped>
.modal-dialog {
    height: 100%;
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
}

.modal-content {
    height: 100%;
    border-radius: inherit;
    border: 0;
}

.close {
    font-size: 2.8rem;
    font-weight: 100;
    color: white;
    text-shadow: none;
    opacity: 1;
}

.zp-modal-head {
    background-color: #3a4339;
    text-align: center;
    padding-top: 5rem;
    padding-bottom: 1rem;
    color: white;
}
</style>
